import React from 'react';

import { InboxItemEmptyContent } from 'src/components/inboxItem';
import { InboxLayout } from 'src/layouts/InboxLayout';

export const EmptyInbox: React.FC = () => {
  return (
    <InboxLayout>
      <InboxItemEmptyContent />
    </InboxLayout>
  );
};
